// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"528":"216deaea","727":"216deaea","888":"216deaea"}[chunkId] + ".chunk.css";
};